import {
    Datagrid,
    downloadCSV,
    NumberField,
    SimpleList,
    TextField,
    ReferenceField,
} from 'react-admin';
import jsonexport from 'jsonexport/dist';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme } from '@mui/material';
import { UploadButton } from '@components/UploadButton';
import { dataObject } from '@src/object.type';
import env from '@src/environment';

export const PriceList = () => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );

    const exporter = (prices: dataObject[]) => {
        const pricesForExport = prices.map(p => {
            const { goods, minimumOrder, price } = p;
            const g = goods as unknown as { [key: string]: string | number };
            return {
                kode_barang: g?.code,
                nama: 'grosir',
                nama_barang: g?.name,
                jumlah_minimal: minimumOrder,
                harga_satuan: price,
            };
        });

        jsonexport(
            pricesForExport,
            {
                headers: [
                    'kode_barang',
                    'nama',
                    'nama_barang',
                    'jumlah_minimal',
                    'harga_satuan',
                ],
            },
            (err, csv) => {
                downloadCSV(
                    csv,
                    `data_harga_${new Date().toLocaleString(env.localFormat)}`
                );
            }
        );
    };

    return (
        <InfiniteList uploadButton={<UploadButton />} exporter={exporter}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => (
                        <ReferenceField source="goodsId" reference="goods">
                            <TextField source="name" />
                        </ReferenceField>
                    )}
                    secondaryText={record => record.minimumOrder}
                    tertiaryText={record => (
                        <NumberField
                            source="price"
                            locales={env.localFormat}
                            textAlign="right"
                        />
                    )}
                />
            ) : (
                <Datagrid>
                    <TextField source="goods.category" />
                    <ReferenceField source="goodsId" reference="goods">
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField source="minimumOrder" />
                    <NumberField
                        source="price"
                        locales={env.localFormat}
                        textAlign="right"
                    />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
